// import { API_BASE_URL, BEARER_TOKEN, BEARER_TOKEN_V2 } from './apiConfig';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const BEARER_TOKEN_V2 = process.env.REACT_APP_BEARER_TOKEN_V2 || '';

interface WelcomeMessage {
  id: string;
  message: string;
}

interface ShortcutMessage {
  id: string;
  message: string;
}

interface PopupsMessage {
  id: string;
  message: string;
}

interface MessagesResponse {
  timestamp: string;
  status: string;
  code: number;
  message: string;
  payload: {
    welcome_message: WelcomeMessage[];
    shortcut_message: ShortcutMessage[];
    popups: PopupsMessage[];
  };
}

export const getMessages = async (
	appId: string,
): Promise<MessagesResponse> => {
	const apiUrl = `${API_BASE_URL}/v2/InfoSolver/application/messages/${appId}`;
	try {
		const requestOptions: RequestInit = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Bearer: BEARER_TOKEN_V2,
			},
		};

		const response = await fetch(apiUrl, requestOptions);
		const data: MessagesResponse = await response.json();

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		return data;
	} catch (error) {
		console.error('Error fetching messages:', error);
		throw error;
	}
};

export default getMessages;
